/**
 * ItemMaster CSV/TSV Parser
 * Supports tab-separated and comma-separated exports
 * Auto-detects delimiter and column positions
 */
import { ADS_BUILTIN, ITEMMASTER_KEY_MAP } from '../data/adsItems.js';

export function parseItemMaster(fileText) {
  const lines = fileText.split('\n').filter(l => l.trim());
  if (lines.length < 2) throw new Error('File appears empty or has only a header row.');
  const sep = lines[0].includes('\t') ? '\t' : ',';
  const headers = lines[0].split(sep).map(h => h.trim().replace(/"/g, '').toLowerCase());
  const lppIdx  = headers.findIndex(h => h.includes('lpp'));
  const partIdx = headers.findIndex(h => h.startsWith('part'));
  const descIdx = headers.findIndex(h => h.includes('desc'));
  const mfrPIdx = headers.findIndex(h => h.includes('manuf. part') || h.includes('manuf part'));
  if (lppIdx < 0) throw new Error(`Could not find LPP column. Found: ${headers.join(', ')}`);
  const lookup = {};
  let count = 0;
  for (let i = 1; i < lines.length; i++) {
    const cols = lines[i].split(sep).map(c => c.replace(/"/g, '').trim());
    const rawLpp = cols[lppIdx]?.replace(/[$,]/g, '');
    const lpp = parseFloat(rawLpp);
    if (!lpp || lpp <= 0) continue;
    const partNo  = cols[partIdx] || '';
    const mfrPart = mfrPIdx >= 0 ? cols[mfrPIdx] : '';
    if (partNo)  lookup[partNo.toLowerCase()]  = { partNo, lpp };
    if (mfrPart) lookup[mfrPart.toLowerCase()] = { partNo: mfrPart, lpp };
    count++;
  }
  // Update ADS keys from ItemMaster
  const updated = { ...ADS_BUILTIN };
  let matched = 0;
  Object.entries(ITEMMASTER_KEY_MAP).forEach(([key, partNos]) => {
    for (const pn of partNos) {
      if (lookup[pn.toLowerCase()]) {
        updated[key] = {
          ...updated[key],
          lpp: lookup[pn.toLowerCase()].lpp,
          fromItemMaster: true,
        };
        matched++;
        break;
      }
    }
  });
  return { updatedADS: updated, totalItems: count, matchedKeys: matched, lookup };
}
